module.exports = __webpack_public_path__ + "static/media/BOL.89ce0331.webp";